import React from 'react';
import WidgetContent from './WidgetContent';
import Loader from '../Loader';

class Widget extends React.PureComponent {
    render() {
        const {analytics, height, width, type, params, hints, instanceType, updateSurveyStatsFromWidget} = this.props;
        return (
            <div style={{gridRowEnd: `span ${height}`, gridColumnEnd: `span ${width}`}}>
                {!analytics || analytics.loading && <div className="loading-container"><Loader /></div>}
                {analytics && !analytics.loading && <WidgetContent type={type} params={params} data={analytics.data}
                    error={analytics.error} hints={hints} instanceType={instanceType} updateSurveyStatsFromWidget={updateSurveyStatsFromWidget} />}
            </div>
        );
    }
}

export default Widget;
